function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  max-width: 100%;\n  height: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f0f0f0;\n  color: #666;\n  padding: 20px;\n  border-radius: 4px;\n  min-height: 100px;\n  min-width: 100px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff5f5;\n  color: #e53e3e;\n  padding: 20px;\n  border-radius: 4px;\n  border: 1px solid #feb2b2;\n  min-height: 100px;\n  min-width: 100px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { tokenManager } from '@edusense/shared-auth-core';
var StyledImage = styled.img(_templateObject());
var LoadingPlaceholder = styled.span(_templateObject1());
var ErrorPlaceholder = styled.span(_templateObject2());
var AuthenticatedImage = function(_param) {
    var src = _param.src, fallbackSrc = _param.fallbackSrc, alt = _param.alt, rest = _object_without_properties(_param, [
        "src",
        "fallbackSrc",
        "alt"
    ]);
    var _useState = _sliced_to_array(useState(undefined), 2), imageSrc = _useState[0], setImageSrc = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), error = _useState2[0], setError = _useState2[1];
    useEffect(function() {
        if (!src) {
            setLoading(false);
            return;
        }
        var objectUrl;
        var isMounted = true;
        var fetchImage = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var requiresAuth, headers, accessToken, response, blob, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            setLoading(true);
                            setError(null);
                            // Check if URL requires authentication (ugot.uk domains)
                            requiresAuth = src.includes('ugot.uk') || src.includes('ugot.svc.cluster.local');
                            headers = {};
                            if (requiresAuth) {
                                accessToken = tokenManager.getToken();
                                console.log('🔐 AuthenticatedImage - Token check:', {
                                    hasToken: !!accessToken,
                                    tokenLength: accessToken === null || accessToken === void 0 ? void 0 : accessToken.length,
                                    tokenPrefix: (accessToken === null || accessToken === void 0 ? void 0 : accessToken.substring(0, 20)) + '...',
                                    url: src
                                });
                                if (accessToken) {
                                    headers['Authorization'] = "Bearer ".concat(accessToken);
                                } else {
                                    console.warn('⚠️ No access token available for authenticated image');
                                }
                            }
                            return [
                                4,
                                fetch(src, {
                                    headers: headers,
                                    mode: 'cors',
                                    credentials: requiresAuth ? 'include' : 'omit'
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw new Error("Failed to fetch image: ".concat(response.status));
                            }
                            return [
                                4,
                                response.blob()
                            ];
                        case 2:
                            blob = _state.sent();
                            // Only update state if component is still mounted
                            if (isMounted) {
                                objectUrl = URL.createObjectURL(blob);
                                setImageSrc(objectUrl);
                                setLoading(false);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error('Error fetching authenticated image:', err);
                            if (isMounted) {
                                setError(_instanceof(err, Error) ? err.message : 'Failed to load image');
                                // Try fallback if available
                                if (fallbackSrc) {
                                    setImageSrc(fallbackSrc);
                                }
                                setLoading(false);
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchImage() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchImage();
        // Cleanup function
        return function() {
            isMounted = false;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [
        src,
        fallbackSrc
    ]);
    if (loading) {
        return /*#__PURE__*/ React.createElement(LoadingPlaceholder, null, "이미지 로딩 중...");
    }
    if (error && !imageSrc) {
        return /*#__PURE__*/ React.createElement(ErrorPlaceholder, null, "이미지 로드 실패");
    }
    if (!imageSrc) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StyledImage, _object_spread_props(_object_spread({}, rest), {
        src: imageSrc,
        alt: alt
    }));
};
export default AuthenticatedImage;
